import { Component, OnInit } from "@angular/core";
import { Group } from "../../model/domain/Group";
import { AuthService } from "../../services/auth.service";
import { DialogService } from "../../services/dialog.service";
import { SecurityService } from "../../services/security.service";
import { SnackbarService } from "../../services/snackbar.service";
import { UserService } from "../../services/user.service";
import { ValidatorService } from "../../services/validator.service";
import { Roles } from "../auth/auth.role";

@Component({
  selector: "app-batch-email",
  templateUrl: "./batch-email.component.html",
  styleUrls: ["./batch-email.component.css"],
})
export class BatchEmailComponent implements OnInit {
  filterStatusAccount: number = 0;
  filterGroupType: string = "0";

  groupsList: Group[] = [];
  emailsList: string = null;
  emailSubject: string = null;
  emailText: string = null;

  constructor(
    public dialogService: DialogService,
    public userService: UserService,
    public securityService: SecurityService,
    public authService: AuthService,
    public validatorService: ValidatorService,
    public snackBarService: SnackbarService
  ) {}

  ngOnInit() {
    this.getGroupsList();
  }

  getGroupsList() {
    const method = this.securityService.GetGroups();

    method.subscribe((res) => {
      this.groupsList = res;
    });
  }

  getEmails() {
    const params: any[] = [this.filterGroupType];
    const method = this.userService.getEmailsList(...params);
    method.subscribe((res) => {
      var emailsTempList = res;
      this.emailsList = emailsTempList.join(", ");
    });
  }

  sendEmail() {
    if (!this.isNullOrEmpty(this.emailsList)) {
      let emailsFinalList = this.emailsList.split(", ");
      let allValid = true;

      emailsFinalList.forEach((email) => {
        if (!this.validatorService.validateEmail(email)) {
          this.dialogService.inform("E-mail inválido: " + email);
          allValid = false;
        }
      });

      if (allValid) {
        const method = this.userService.sendBatchEmail(
          emailsFinalList,
          this.emailSubject,
          this.emailText
        );
        method.subscribe((res) => {
          const msg = "E-mail enviado.";

          this.snackBarService.open(msg, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
        });
      }
    }
  }

  sendButtonDisabled() {
    return (
      this.isNullOrEmpty(this.emailsList) ||
      this.isNullOrEmpty(this.emailText) ||
      this.isNullOrEmpty(this.emailSubject)
    );
  }

  isNullOrEmpty(str: string) {
    return str == null || str == "";
  }

  canSendBatchEmail() {
    const roles = [Roles.SendBatchEmail];

    return this.authService.hasRoles(roles);
  }
}
